import type {PublicMethodUtils} from '@wix/document-services-types'
import {variables} from '@wix/document-services-implementation'

export default function (publicMethodUtils: PublicMethodUtils) {
    return {
        methods: {
            variables: {
                VARIABLE_TYPES: publicMethodUtils.extensionPublicAPI.constants('variables.VARIABLE_TYPES'),
                SUPPORTED_VARIABLE_TYPES: publicMethodUtils.extensionPublicAPI.constants(
                    'variables.SUPPORTED_VARIABLE_TYPES'
                ),
                getVariableReferences: publicMethodUtils.extensionPublicAPI.getter('variables.getVariableReferences')
            },
            global: {
                variables: {
                    getPointerByCssVarName: publicMethodUtils.extensionPublicAPI.getter(
                        'global.variables.getPointerByCssVarName'
                    ),
                    getByTypes: publicMethodUtils.extensionPublicAPI.getter('global.variables.getByTypes'),
                    list: publicMethodUtils.extensionPublicAPI.getter('global.variables.list'),
                    get: publicMethodUtils.defineGetter(variables.getGlobalVariable),
                    add: publicMethodUtils.defineDataManipulationAction(variables.addGlobalVariable, {
                        getReturnValue: variables.getVariableToAddRef
                    }),
                    remove: publicMethodUtils.defineDataManipulationAction(variables.removeGlobalVariable),
                    update: publicMethodUtils.defineDataManipulationAction(variables.updateGlobalVariableDefinition),
                    value: {
                        get: publicMethodUtils.defineGetter(variables.getGlobalVariableData),
                        remove: publicMethodUtils.defineGetter(variables.removeGlobalVariableData),
                        update: publicMethodUtils.defineGetter(variables.updateGlobalVariableData)
                    },
                    getParentVariables: publicMethodUtils.extensionPublicAPI.getter(
                        'global.variables.getParentVariables'
                    ),
                    getChildVariables: publicMethodUtils.extensionPublicAPI.getter('global.variables.getChildVariables')
                }
            },
            components: {
                variables: {
                    list: publicMethodUtils.defineGetter(variables.getComponentVariablesList),
                    get: publicMethodUtils.defineGetter(variables.getVariable),
                    add: publicMethodUtils.defineDataManipulationAction(variables.addVariable, {
                        getReturnValue: variables.getVariableToAddRef
                    }),
                    addWithCustomId: publicMethodUtils.defineDataManipulationAction(variables.addVariableWithCustomId),
                    remove: publicMethodUtils.defineDataManipulationAction(variables.removeVariable),
                    update: publicMethodUtils.defineDataManipulationAction(variables.updateVariableDefinition),
                    getComponentsUsingVariable: publicMethodUtils.defineGetter(variables.getComponentsUsingVariable),
                    getVariableConnections: publicMethodUtils.defineGetter(variables.getVariableConnections),
                    getComponentVariableConnections: publicMethodUtils.defineGetter(
                        variables.getComponentVariableConnections
                    ),
                    connect: publicMethodUtils.defineGetter(variables.connect),
                    disconnect: publicMethodUtils.defineGetter(variables.disconnect),
                    value: {
                        get: publicMethodUtils.defineGetter(variables.getVariableData),
                        remove: publicMethodUtils.defineDataManipulationAction(variables.removeVariableData),
                        update: publicMethodUtils.defineDataManipulationAction(variables.updateVariableData)
                    }
                }
            }
        }
    }
}
